import { cn } from '../../../shared/utils';

interface PreviewTextBoxProps {
    text?: string | null;
    customStyles?: string;
}

export default function PreviewTextBox({ text, customStyles }: PreviewTextBoxProps) {
    return (
        <div
            className={cn(
                "flex h-full min-h-[50px] w-full items-center justify-center p-2 text-xl font-bold text-gray-600",
                customStyles,
            )}>
            <span className={"markdown text-center"}>{text || ""}</span>
        </div>
    );
}
